import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * @file toast组件 显示倒计时
 * @author jianghaoran01
 */
import React, { useState, useEffect } from 'react';
import NotificationApi from './base';
import classNames from 'classnames';
import { globalConfig, defaultPrefixCls as providerDefaultPrefixCls } from '../config-provider';

var _globalConfig = globalConfig(),
    getPrefixCls = _globalConfig.getPrefixCls;

var PREFIX = 'notification-hastime';
var defaultPrefixCls = providerDefaultPrefixCls;
var maxToastArrLength = 4; // 最多显示多少个toast

/**
 * 代理对象
 * 使用时: target.xxx会全部丢给notification 类似notification.xxx
 */

var target = {};
var toastArr = []; // const paramIgnoreFun = ['close', 'destroy'];
// 向数组尾部添加一个元素

function addToastKey(key) {
  toastArr.push(key);
} // 弹出数组头部元素


function unshiftToast() {
  return toastArr.splice(0, 1)[0];
} // 移除数组元素


function removeToastKey(key) {
  for (var i = 0; i < toastArr.length; i++) {
    if (key === toastArr[i]) {
      toastArr.splice(i, 1);
      break;
    }
  }
}

function ToastDom(props) {
  var message = props.message,
      description = props.description,
      countdown = props.countdown,
      notificationKey = props.notificationKey,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? null : _props$onClose,
      customizePrefixCls = props.prefixCls;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      setTimerID = _useState2[1];

  var _useState3 = useState(countdown),
      _useState4 = _slicedToArray(_useState3, 2),
      counter = _useState4[0],
      setCounter = _useState4[1]; // const prefixCls = getPrefixCls('toast-wrap', '');


  var prefixCls = getPrefixCls('', customizePrefixCls || defaultPrefixCls) + '-toast-wrap';
  useEffect(function () {
    if (counter !== undefined) {
      if (counter > 0) {
        // clearTimeout(timerID);
        var timer = setTimeout(function () {
          setCounter(counter - 1);
        }, 1000);
        setTimerID(timer);
      }

      if (counter === 0) {
        NotificationApi.close(notificationKey);
        onClose && onClose();
        removeToastKey(notificationKey);
      }
    }

    return function () {
      // destory时可能timerID并没有 但是计时器存在 设置值时react会警告
      // if (timerID) {
      setTimerID(null); // }
    };
  }, [counter]); // useEffect(() => {
  //     return () => {
  //         clearTimeout(timerID);
  //     }
  // }, []);

  return /*#__PURE__*/React.createElement("div", {
    className: getPrefixCls('', customizePrefixCls || defaultPrefixCls) + '-notification-toast-wrap'
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(getPrefixCls('', customizePrefixCls || defaultPrefixCls), "-notification-toast-wrap-left"), _defineProperty({}, prefixCls + '-no-description', !description))
  }, message), counter === undefined ? null : /*#__PURE__*/React.createElement("div", {
    className: getPrefixCls('', customizePrefixCls || defaultPrefixCls) + '-notification-toast-wrap-right'
  }, "(", counter, /*#__PURE__*/React.createElement("span", null, "s"), ")"));
}

function DescriptionDom(props) {
  var description = props.description;
  return description ? /*#__PURE__*/React.createElement("div", {
    className: "description-wrap"
  }, description) : null;
}

var handler = {
  get: function get() {
    var name = arguments.length <= 1 ? undefined : arguments[1]; // 关闭、删除提示可以根据用户传参直接调用，避免key错赋值
    // if (paramIgnoreFun.includes(name)) {
    //     return props => Reflect.get(NotificationApi, name)(props);
    // }

    var key = new Date().getTime() + ''; // 通过key来强制关闭notification

    return function (props) {
      // 定义默认图标
      var iconProps = {
        icon: null
      };

      var args = _extends(_extends({
        key: key,
        type: 'info'
      }, iconProps), props); // 设置最大显示数


      if (name === 'config' && props.maxCount) {
        maxToastArrLength = props.maxCount;
      } // 设置prefixcls 兼容antd


      if (name === 'config' && props.prefixCls) {
        defaultPrefixCls = props.prefixCls;
      } // key相同时不重新渲染


      if (!~toastArr.indexOf(args.key)) {
        if (toastArr.length < maxToastArrLength) {
          addToastKey(args.key);
        } else {
          NotificationApi.close(unshiftToast());
          addToastKey(args.key);
        }
      } // 初始化倒计时
      // let tempDuration;
      // if (!args.duration) {
      //     tempDuration = 0;
      // }
      // else {
      //     tempDuration = args.duration;
      // }


      var tempDuration = args.duration;
      args.duration = 0; // 设置样式 有描述和没描述间距不一样

      var tempClassName = (props === null || props === void 0 ? void 0 : props.className) + ' ' + PREFIX;

      if (args.description) {
        tempClassName += ' ' + getPrefixCls('', (props === null || props === void 0 ? void 0 : props.prefixCls) || defaultPrefixCls) + '-notification-has-description';
      }

      if (props && props.className) {
        args.className = props.className + ' ' + tempClassName;
      } else {
        args.className = tempClassName;
      } // 设置DOM


      args.message = /*#__PURE__*/React.createElement(ToastDom, {
        message: args.message,
        description: args.description,
        countdown: tempDuration,
        notificationKey: args.key,
        onClose: props === null || props === void 0 ? void 0 : props.onClose,
        prefixCls: props === null || props === void 0 ? void 0 : props.prefixCls
      });
      args.description = /*#__PURE__*/React.createElement(DescriptionDom, {
        description: args.description
      });
      return Reflect.get(NotificationApi, name)(args);
    };
  }
};
var toast = new Proxy(target, handler);
export default toast;